import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '@/services/apiClient'
import type {
  IntegrationCatalogResponse,
  ProviderConfig,
  ProviderConfigUpdate,
} from '@/types/integrations'

export function useIntegrationCatalog() {
  return useQuery({
    queryKey: ['integration-catalog'],
    queryFn: () => apiClient.get<IntegrationCatalogResponse>('/api/integrations/catalog'),
  })
}

export function useProviderConfig(adapterId: string, enabled = true) {
  return useQuery({
    queryKey: ['provider-config', adapterId],
    queryFn: () =>
      apiClient.get<ProviderConfig>(`/api/integrations/${adapterId}/provider-config`),
    enabled: enabled && adapterId.length > 0,
  })
}

export function useSaveProviderConfig() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ adapterId, ...body }: { adapterId: string } & ProviderConfigUpdate) =>
      apiClient.put<ProviderConfig>(`/api/integrations/${adapterId}/provider-config`, body),
    onSuccess: (_data, { adapterId }) => {
      qc.invalidateQueries({ queryKey: ['provider-config', adapterId] })
      qc.invalidateQueries({ queryKey: ['integration-catalog'] })
    },
  })
}
